export enum RemoteControlKey {
  Portal = 36,  // Home on Elsys
  NET = 409,
  Mosaico = 62724,
  Info = 457,
  RedButton = 129,
  VolumeUp = 175,
  VolumeDown = 174,
  Mute = 173,
  Back = 27,
  ChannelUp = 427,
  ChannelDown = 428,
  Exit = 601,
  NET_TV = 458,
  Up = 38,
  Down = 40,
  Left = 37,
  Right = 39,
  OK = 13,
  ITV = 403,
  Audio = 404,
  Agora = 61501,
  Subtitle = 405,
  Message = 406,
  Favorite = 171,
  Menu = 93,
  Rewind = 412,
  Play = 179,
  Forward = 417,
  Replay = 61523,
  Stop = 178,
  Record = 416,
  PPV = 62720,
  NOW = 62722,
  Music = 61487,
  One = 49,
  Two = 50,
  Three = 51,
  Four = 52,
  Five = 53,
  Six = 54,
  Seven = 55,
  Eight = 56,
  Nine = 57,
  Zero = 48,
  Backspace = 8,  // Back on Elsys
  Plus = 187,
  Minus = 189,
  A = 65,
  B = 66,
  C = 67,
  D = 68,
  E = 69,
  F = 70,
  G = 71,
  H = 72,
  I = 73, // Info on Elsys
  J = 74,
  K = 75,
  L = 76,
  M = 77,
  N = 78,
  O = 79,
  P = 80,
  Q = 81,
  R = 82,
  S = 83,
  T = 84,
  U = 85,
  V = 86,
  W = 87,
  X = 88,
  Y = 89,
  Z = 90,
  Undefined
}

export class RemoteEvent {
  Key: string;
  KeyCode: number;
  RemoteKey: RemoteControlKey | string;

  constructor() {
    this.Key = 'Undefined';
    this.KeyCode = -1;
    this.RemoteKey = RemoteControlKey.Undefined;
  }
}
